import * as angular from 'angular';

import ApiService from './api.service';
import UsersService from './users.service';
import RfpService from './rfps/rfp.service';
import TransactionStatusesService from './transactionStatuses.service';

import OfferHelperService from './helpers/offerHelper.service';
import OfferTypeHelperService from './helpers/offerTypeHelper.service';
import {
  PurchasePlanningPermissions,
  ResponsePermissions
} from './helpers/permissions.service';
import RfpHelperService from './helpers/rfpHelper.service';

// TODO: Delete these services and just use the main api service everywhere
// Better yet, just import the specific service you need
export default angular
  .module('api', ['httpInterceptor'])

  // Uncommenting these because they're used by e2e tests
  .service('api.UsersService', UsersService)
  .service('api.rfps', RfpService)
  .service('api.transactionStatuses', TransactionStatusesService)
  .service('OfferHelper', OfferHelperService)
  .service('OfferTypeHelper', OfferTypeHelperService)
  .service('ResponsePermissions', ResponsePermissions)
  .service('PurchasePlanningPermissions', PurchasePlanningPermissions)
  .service('RfpHelper', RfpHelperService)
  .factory('api', ApiService).name;
